import { call, put, takeLatest } from 'redux-saga/effects'
import apiCall from '../helpers/apiCall'
import { PUT } from '../consts/methods'
import { SET_LOADER } from 'dealer-reducers'
import {
  UPDATE_SELL_CONTRACT,
  UPDATE_SELL_CONTRACT_FAILURE,
  UPDATE_SELL_CONTRACT_SUCCESS,
  UpdateSellContractActionType
} from 'src/redux/sellContractReducer'

// eslint-disable-next-line @typescript-eslint/no-explicit-any
function* UpdateSellContractFlow(action: UpdateSellContractActionType): Generator<any, void, any> {
  try {
    yield put(SET_LOADER(true))
    const response: { pdf_url: string } = yield call(apiCall, {
      method: PUT,
      endpoint: `/dealers_api/sell_contracts/${action.payload.id}`,
      api: 'market-api',
      params: {
        sell_contract: action.payload.values
      }
    })
    yield put(UPDATE_SELL_CONTRACT_SUCCESS({ pdf_url: response.pdf_url }))
  } catch (error) {
    yield put(UPDATE_SELL_CONTRACT_FAILURE())
  } finally {
    yield put(SET_LOADER(false))
  }
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export default function* UpdateSellContractSaga(): Generator<any, void, any> {
  yield takeLatest(UPDATE_SELL_CONTRACT, UpdateSellContractFlow)
}
